import React from 'react'
import { CenterBox } from '@repo/ui/components/center-box'
import { Icon } from '@repo/ui/components/icon'
import { Typography } from '@repo/ui/components/typography'
import { Button } from '@repo/ui/components/button'
import { useTranslate } from '@repo/shared/hooks'
import { Modal, ModalContent, ModalTrigger } from '@repo/ui/components'
import { useUserAuthDetails } from '@repo/services'

import { KycBlocker } from '@repo/shared/components'
import { CardInput } from './card-input.component'

export const CardEmptyState = () => {
  const { t } = useTranslate()
  const { data: authDetails } = useUserAuthDetails()
  const hasKyc =
    authDetails?.data.details?.kyc &&
    authDetails?.data.details?.kyc?.status === 'approved'
  return (
    <CenterBox className=' flex-col gap-lg py-10xl'>
      <Icon name='CardGhost' size='lg' color='fill-base-surface-100' />
      <Typography
        variant='p'
        size='sm'
        color='text-base-surface-100'
        className='text-center'
      >
        {t('addCardPage_empty_state_message')}
      </Typography>

      <Modal>
        <ModalTrigger asChild>
          <Button
            variant='fill'
            size='sm'
            color='base'
            startIcon={<Icon name='PlusLine' size='xs' color='fill-current' />}
          >
            {t('cardsPage_button')}
          </Button>
        </ModalTrigger>
        <ModalContent className='sm:max-w-[425px]'>
          {hasKyc ? (
            <CardInput />
          ) : (
            <KycBlocker
              phone={authDetails?.data.phone}
              email={authDetails?.data.email}
              kyc={authDetails?.data.details?.kyc}
            />
          )}
        </ModalContent>
      </Modal>
    </CenterBox>
  )
}
